import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-attr-date-time',
  templateUrl: './attr-date-time.component.html',
  styleUrls: ['./attr-date-time.component.scss'],
  standalone: false,
})
export class AttrDateTimeComponent implements OnInit {
  @Input() propertyId: string;
  @Input() caption: string;
  @Input() value: Date;
  @Input() mandatory: boolean;
  @Input() isDisabled: boolean;

  constructor() {}

  ngOnInit(): void {}
}
